import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BASE_URL } from './app/shared/constants';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLicense } from "@syncfusion/ej2-base";

export function getBaseUrl() {
    return document.getElementsByTagName("base")[0].href;
}

const providers = [{ provide: BASE_URL, useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
    enableProdMode();
}

registerLicense(
    "Mgo+DSMBaFt9QHJqVEdrXVNbdV5dVGpAd0N3RGlcdlR1fUUmHVdTRHRcQlRjSH5UdUBmXXpWcnI=;Mgo+DSMBMAY9C3t2V1hiQlBFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5adkRjXnxbdXBQT2ha"
);

platformBrowserDynamic(providers).bootstrapModule(AppModule)
    .catch((err: any) => console.log(err));
